module.exports = __webpack_public_path__ + "media/app/images/airtable-41601835df0d90ecf04e6062f922edcc.png";